// =====================================================
// FEED AD PLACEMENT
//
// Exactly one advertisement after every 7 blogs:
//   Blog 1 … Blog 7 → Ad (slot 1) → Blog 8 … Blog 14 → Ad (slot 2) → …
//
// Positions are counted over the WHOLE list, not per page, so the pattern
// runs straight across page boundaries (with 10 blogs a page, slot 1 is
// after blog 7 on page 1 and slot 2 after blog 14 on page 2). The blogs
// themselves are never reordered or removed.
// =====================================================

export const AD_EVERY_N_BLOGS = 2;

// 1-based position of a blog in the whole list → the ad slot that follows
// it, or 0 when no ad follows it.
export function adSlotAfter(position) {
  return position > 0 && position % AD_EVERY_N_BLOGS === 0 ? position / AD_EVERY_N_BLOGS : 0;
}

// The ad slots that fall on one page, each with the ids of the blogs just
// before it (the slot's contextual categories come from those).
export function adSlotsForPage(list, page, perPage) {
  const start = (page - 1) * perPage;
  const end = Math.min(list.length, start + perPage);
  const slots = [];
  for (let position = start + 1; position <= end; position += 1) {
    const slot = adSlotAfter(position);
    if (!slot) continue;
    slots.push({
      slot,
      blogIds: list.slice(position - AD_EVERY_N_BLOGS, position).map((b) => b._id),
    });
  }
  return slots;
}
